// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const CLASSIFICATION_TYPE_VALUES = [
  'INTERVAL',
  'UNIQUE_VALUES',
] as const;

/** @see net/disy/cadenza/repository/api/objecttype/ClassificationType.java */
export type ClassificationType = (typeof CLASSIFICATION_TYPE_VALUES)[number];

export const ClassificationType = {
  values: CLASSIFICATION_TYPE_VALUES as readonly ClassificationType[],
} as const;

// </GENERATED-CODE>

import type { GraphicalPropertyType } from 'cadenza/api-client/model/graphical-property-type.gen';

// Keep in sync with VisualizationConfigUtilities::BUNDLE_TO_SUPPORTED_CLASSIFICATION_TYPE
export function getSupportedStandardClassificationTypes (graphicalPropertyType: GraphicalPropertyType): ClassificationType[] {
  switch (graphicalPropertyType) {
    case 'imageLocation':
      return [ 'UNIQUE_VALUES' ];
    case 'symbolSize':
      return [ 'INTERVAL' ];
    case 'foregroundColor':
      return [ 'UNIQUE_VALUES', 'INTERVAL' ];
    default:
      throw new Error(`${graphicalPropertyType} not supported.`);
  }
}
